// extracted by mini-css-extract-plugin
export default {"wrapper":"popup_wrapper__vXN13","box":"popup_box__A8m+8"};